module.exports = __webpack_public_path__ + "media/images/common/ico-cart-1bc4d95308a60b0e60d3f65d0e1d32c3.svg";